const euroFormatter = new Intl.NumberFormat("it-IT", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function formatEuro(amount: number): string {
  return `${euroFormatter.format(amount)} €`
}

const sizeUnits = ["B", "KB", "MB", "GB"]

export function formatBytes(bytes: number): string {
  let i = 0
  let v = bytes
  while (v >= 1024 && i < sizeUnits.length - 1) {
    v /= 1024
    i++
  }
  if (i === 0) return `${bytes} ${sizeUnits[0]}`
  return `${euroFormatter.format(v)} ${sizeUnits[i]}`
}

export function isoWeekOf(date: Date): string {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()))
  const dayNum = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum)
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  const weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7)
  return `${d.getUTCFullYear()}-W${String(weekNo).padStart(2, "0")}`
}
